export default class MarkersUtil {
    static getFields(isPublicFields) {
        let fields = {
            projectReference: true,
            longitude: true,
            latitude: true,
            creationInfos: true,
            modificationInfos: true,
            customReference: true,
            tags: true,
            title: true,
            description: true
        };

        if (isPublicFields) {
            delete fields.projectReference;
            delete fields.customReference;
        }

        return fields;
    }
}
